<div class="client-container d-flex flex-column webinar-detail-page">
    @if (!isLoading) {
        <app-webinars-detail
                (delete)="delete()"
                (openPreview)="openPreview()"
                (refreshAnalytics)="refreshAnalytics()"
                (save)="save()"
                (closeEngagement)="closeEngagement($event)"
                (createEngagement)="createEngagement($event)"
                (deleteEngagement)="deleteEngagement($event)"
                (publishEngagement)="publishEngagement($event)"
                (refreshEngagements)="refreshEngagements()"
                (updateEngagement)="updateEngagement($event)"
                (moderateChat)="moderateChat($event)"
                (previewSeries)="previewSeries()"
                [form]="form"
                [isSaving]="isSaving"
                [chatMessages]="chatMessages"
                [pinnedChatMessageId]="pinnedChatMessageId"
                [isChatLoading]="isChatLoading"
                [analytics]="webinarAnalytics"
                [isAnalyticsLoading]="isAnalyticsLoading"
                [analyticsErrorMessage]="analyticsErrorMessage"
                [engagementItems]="engagementItems"
                [isEngagementLoading]="isEngagementLoading"
                [registrationColumns]="registrationColumns"
                [registrations]="registrations"
                [selectedWebinar]="selectedWebinar"
                [hasHostPassword]="hasHostPassword"
                [hostPasswordMasked]="hostPasswordMasked"
                [recurrencePreviewOccurrences]="recurrencePreviewOccurrences"
                [recurrencePreviewSeries]="recurrencePreviewSeries"
                [isRecurrencePreviewLoading]="isRecurrencePreviewLoading"
                [recurrencePreviewError]="recurrencePreviewError"
        ></app-webinars-detail>
    } @else {
    <div class="webinar-detail__loading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    }
</div>
